/*****
 *
 *
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var DataSourcesCountModel = require("manager-models/DataSourcesCountModel");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");

    var MetricsDataSourcesController = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        MetricsDataSourcesController = Marionette.Controller.extend({

        });

    });

    var _getJsonMetricsCounter = function(jsonMetrics) {
        return _.map(jsonMetrics, function(metric) { return  metric.counter; });
    };

    var _typesArrayToString = function (typesArr) {
        if (_.isString(typesArr)) {
            return typesArr;
        } else {
            return typesArr.join();
        }
    };

    /***
     * return DateSources Metrics as Json
     * @param options - this object is transferred in the success callback function in addition to the result
     *          options.success - the callback function
     *          options.types - Array of types or single type
     */
    var getDataSourcesJsonMetrics =  function(options){
        var metricTypes = _typesArrayToString(options.types);
        var timeFrame = options.timeFrame || ManagerConfig.dataSources.mainConfig.dataSourcesCount.timeFrame;
        var dataSourcesCountModel = new DataSourcesCountModel({metricType: metricTypes, timeFrame: timeFrame});
        dataSourcesCountModel.fetchCount({success: function(data) {
            if (options.success && _.isFunction(options.success)) {
                options.success(data, options);
            }
        },error: function(error) {
            if (options.error && _.isFunction(options.error)) {
                options.error(error, options);
            }
        }});
    };

    var isMetricsConnected = function (options) {
        var innerOptions = {
            types: options.types,
            success: function(data) {
                var metrics = data.get("dataMetrics");
                var connectionCount = _getJsonMetricsCounter(metrics);
                if (connectionCount.length === 1) {
                    options.success(_.first(connectionCount) > 0);
                } else {
                    var res = [];
                    _.each(options.types, function(type) {
                        var metric = _.findWhere(metrics, function(metric) {
                            return (metric.metricType === type);
                        });
                    });
                    options.success(res);
                }
            },
            error: function(error) {
                options.error(error);
            }
        };
        getDataSourcesJsonMetrics(innerOptions);
    };

    var METRICS_IDS = {
        "CART_EVENT": 3,
        "MARKETING_INFO_EVENT": 6,
        "TRANSACTION_INFO_EVENT": 2,
        "LEAD_INFO_EVENT": 4,
        "VIEWED_PRODUCT_EVENT": 5,
        "CUSTOMER_INFO_EVENT": 7,
        "PERSONAL_INFO_EVENT": 8,
        "SERVICE_ACTIVITY_EVENT": 9,
        "VISITOR_ERROR_EVENT": 10,
        "LOCATION_SECTIONS_EVENT": 11,
        "AUTHENTICATION_SERVER_EVENT": 107
    };

    var METRIC_TYPES = {
        CART_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.CART_EVENT.toString()],
        MARKETING_INFO_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.MARKETING_INFO_EVENT.toString()],
        TRANSACTION_INFO_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.TRANSACTION_INFO_EVENT.toString()],
        LEAD_INFO_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.LEAD_INFO_EVENT.toString()],
        VIEWED_PRODUCT_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.VIEWED_PRODUCT_EVENT.toString()],
        CUSTOMER_INFO_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.CUSTOMER_INFO_EVENT.toString()],
        PERSONAL_INFO_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.PERSONAL_INFO_EVENT.toString()],
        SERVICE_ACTIVITY_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.SERVICE_ACTIVITY_EVENT.toString()],
        VISITOR_ERROR_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.VISITOR_ERROR_EVENT.toString()],
        LOCATION_SECTIONS_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.LOCATION_SECTIONS_EVENT.toString()],
        AUTHENTICATION_SERVER_EVENT: ManagerConfig.dataSources.mapping.itemToMetric[METRICS_IDS.AUTHENTICATION_SERVER_EVENT.toString()]
    };

    MetricsDataSourcesController.METRICS_IDS = METRICS_IDS;
    MetricsDataSourcesController.METRIC_TYPES = METRIC_TYPES;
    MetricsDataSourcesController.getDataSourcesJsonMetrics = getDataSourcesJsonMetrics;
    MetricsDataSourcesController.isMetricsConnected = isMetricsConnected;
    return MetricsDataSourcesController;
});
